import { Link } from 'react-router-dom';
import { articlePreview } from '@/mocks/categories';

export default function ArticleCTA() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="relative rounded-2xl overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20and%20inviting%20reading%20nook%20with%20an%20open%20notebook%20and%20a%20steaming%20cup%20of%20coffee%20on%20a%20wooden%20side%20table%2C%20a%20cozy%20throw%20blanket%20draped%20over%20a%20cream%20armchair%2C%20soft%20natural%20window%20light%20creating%20gentle%20shadows%2C%20peaceful%20and%20contemplative%20atmosphere%2C%20editorial%20lifestyle%20photography%20with%20rich%20textures%20of%20linen%20and%20wood%2C%20quiet%20luxury%20aesthetic&width=1200&height=500&seq=article-cta-v2&orientation=landscape"
              alt="Read Basetao Spreadsheet guide"
              title="Basetao Spreadsheet Complete Guide"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 to-foreground-950/40"></div>
          </div>

          <div className="relative z-10 p-8 md:p-12">
            <div className="max-w-lg">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-400/20 text-accent-300 text-xs font-semibold mb-4 backdrop-blur-sm">
                Featured Guide
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
                {articlePreview.title}
              </h2>
              <p className="text-background-50/70 text-sm leading-relaxed mb-2">
                {articlePreview.excerpt}
              </p>
              <div className="flex items-center gap-4 text-xs text-background-50/50 mb-6">
                <span className="flex items-center gap-1">
                  <i className="ri-time-line"></i>
                  {articlePreview.readTime}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-calendar-line"></i>
                  {articlePreview.date}
                </span>
              </div>
              <Link
                to={articlePreview.slug}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-book-open-line"></i>
                Read Full Guide
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}